import dataUtils from "@/utils/data";
export default class Grupo {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.descricao = obj.descricao;
    this.dataCriacao = obj.dataCriacao;
    this.loginUsuarioCriador = obj.loginUsuarioCriador;
    this.idUsuarioCriador = obj.idUsuarioCriador;
    this.loginsFuncionarios = obj.loginsFuncionarios;
    this.funcionariosGrupo = obj.funcionariosGrupo;
  }

  aplicarMascaraData() {
    this.dataCriacao = dataUtils.aplicarMascaraEmDataIso(this.dataCriacao);
  }
}
